module.exports = __webpack_public_path__ + "static/media/uz.0b281dd5.svg";